export class ManquementCommissionEdition {
    static jsonMap = {
        date: { key: 'date', optional: true, default: '' },
        adresse: { key: 'adresse', optional: true, default: '' },
        numero: { key: 'numero', optional: true, default: '' }
    };

    date: string;
    adresse: string;
    numero: string;
}
